import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AudioState {
  musicVolume: number;
  sfxVolume: number;
  voiceVolume: number;
  musicMuted: boolean;
  sfxMuted: boolean;
  voiceMuted: boolean;

  setMusicVolume: (v: number) => void;
  setSfxVolume: (v: number) => void;
  setVoiceVolume: (v: number) => void;
  toggleMusic: () => void;
  toggleSfx: () => void;
  toggleVoice: () => void;
  muteAll: (mute: boolean) => void;
}

const clamp = (v: number) => Math.min(1, Math.max(0, v));

export const useAudioStore = create<AudioState>()(
  persist(
    (set) => ({
      musicVolume: 0.5,
      sfxVolume: 0.8,
      voiceVolume: 1.0,
      musicMuted: false,
      sfxMuted: false,
      voiceMuted: false,

      setMusicVolume: (v) => set({ musicVolume: clamp(v) }),
      setSfxVolume: (v) => set({ sfxVolume: clamp(v) }),
      setVoiceVolume: (v) => set({ voiceVolume: clamp(v) }),
      toggleMusic: () => set((s) => ({ musicMuted: !s.musicMuted })),
      toggleSfx: () => set((s) => ({ sfxMuted: !s.sfxMuted })),
      toggleVoice: () => set((s) => ({ voiceMuted: !s.voiceMuted })),
      muteAll: (mute) => set({ musicMuted: mute, sfxMuted: mute, voiceMuted: mute }),
    }),
    { name: "spieleparadies.audio" },
  ),
);

/** Effektive Lautstärke für Musik (berücksichtigt Mute). */
export function effectiveMusicVolume(state: AudioState): number {
  return state.musicMuted ? 0 : state.musicVolume;
}
export function effectiveSfxVolume(state: AudioState): number {
  return state.sfxMuted ? 0 : state.sfxVolume;
}
export function effectiveVoiceVolume(state: AudioState): number {
  return state.voiceMuted ? 0 : state.voiceVolume;
}
